// NAT => Non Arrival Ticket
export default {
  "operation.NAT.dialogTitle": "未着券計上",
  "operation.NAT.advanceTicket": "全国共通券/劇場前売券",
  "operation.NAT.qty": "枚数",
  "operation.NAT.device": "デバイス",
  "operation.NAT.comment": "コメント",
  "operation.NAT.screenDate": "上映日付",
  "operation.NAT.showTime": "上映時間",
  "operation.NAT.createTime": "操作日時",
  "operation.NAT.scheduleStartTime": "上映日時",
  "operation.NAT.startTime": "開始時間",
  "operation.NAT.ticketType": "券種",
  "operation.NAT.qty": "枚数",
  "operation.NAT.amountOfBoxOfficeRevenue": "興行収入計上金額",
  "operation.NAT.changePeople": "担当者",
  "operation.NAT.NATIONWIDE": "全国共通券",
  "operation.NAT.PRE_SALES": "全国共通券",

  "operation.NAT.placeholder.input": "入力してください",
};